export default store => {
  store.subscribe((mutation) => {
    if (mutation.type === 'resetState') {
      // store 重置
      const initialState = { ...store._modules.root.state }; // 复制初始状态
      store.replaceState(initialState);
    }
    if (mutation.type === 'optimize/RESET_STATE') {
      // store/optimize 重置
      store.state.optimize = { ...store._modules.root.state.optimize }
      const vuex_localStorage = JSON.parse(localStorage.getItem('vuex'))
      vuex_localStorage.optimize = store._modules.root.state.optimize
      localStorage.setItem('vuex', JSON.stringify(vuex_localStorage))
    }
  });
};